import React from "react";
import styled from "styled-components";
import Modal from "react-modal";
import Button from "../Buttons";
import { Colors } from "../../ColorConstants";

const FreeTicketModal = ({ onClosePromoModal, isPromoOpen, count }) => {
  return (
    <Modal
      isOpen={isPromoOpen}
      onRequestClose={onClosePromoModal}
      contentLabel="Modal confirmation"
      style={{
        content: {
          height: "auto",
          width: "auto",
          display: "grid",
          justifyContent: "center",
          padding: 0,
          background: "transparent",
          border: "none",
          position: "unset",
          borderRadius: 0,
          background: "white",
          padding: "2rem",
          borderRadius: "1rem",
        },
        overlay: {
          backgroundColor: "rgba(0, 0, 0, 0.7)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
      }}
    >
      <PromoModalContainer>
        <PromoImg src={require("../../assets/images/trophy.png")} />
        <PromoDetailsContainer>
          <Savings>HURRAY!</Savings>
          <PromoCode style={{ color: "black" }}>
            {`You’ve earned ${count} free ticket${count > 1 ? 's!':'!'}`}
          </PromoCode>
          <Button
            label="Continue!"
            backgroundColor={Colors.aqua}
            variant="filled"
            onClick={onClosePromoModal}
          />
        </PromoDetailsContainer>
      </PromoModalContainer>
    </Modal>
  );
};

const PromoImg = styled.img`
  width: 6rem;
`;

const PromoCode = styled.div`
  padding-top: 1rem;
  font-size: 1.1rem;
  color: ${Colors.grey};
  padding-bottom: 1.5rem;
`;
const Savings = styled.div`
  font-size: 1.8rem;
  font-weight: 700;
  color: ${Colors.aqua};
`;
const PromoDetailsContainer = styled.div`
  // padding: 2rem;
  background: white;
  width: 100%;
  border-radius: 1rem;
  box-sizing: border-box;
  text-align: center;
  display: flex;
  flex-direction: column;
`;

const PromoModalContainer = styled.div`
  min-width: 15rem;
  max-width: 15rem;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export default FreeTicketModal;
